import { render, staticRenderFns } from "./SetPasswordModal.vue?vue&type=template&id=1949811a&scoped=true"
import script from "./SetPasswordModal.vue?vue&type=script&lang=js"
export * from "./SetPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordModal.vue?vue&type=style&index=0&id=1949811a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949811a",
  null
  
)

export default component.exports